
<div
  v-if="showBreadcrumbs"
  class="mb-3 pb-3 d-flex align-items-center"
  :style="{ height: '22px' }"
>
  <span v-if="prefix" class="text-muted mr-1">
    {{ prefix }}
  </span>
  <Icon v-if="prefix" icon="angle-right" class="text-muted mr-1" size="18" />
  <RouterLink
    :to="{
      name: items[0].to.name,
    }"
  >
    <Icon icon="folder" class="blue" size="18" />
  </RouterLink>
  <b-breadcrumb :items="getBreadcrumbs()"></b-breadcrumb>
</div>
